/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */
import type {
  AccountResponse
} from '../../schemas';

import { customFetchProtected } from '../../../custom-fetcher';

export type findWithInitialDataResponse200 = {
  data: AccountResponse
  status: 200
}

export type findWithInitialDataResponseSuccess = (findWithInitialDataResponse200) & {
  headers: Headers;
};
;

export type findWithInitialDataResponse = (findWithInitialDataResponseSuccess)

export const getFindWithInitialDataUrl = () => {




  return `/api/v1/accounts`
}

export const findWithInitialData = async ( options?: RequestInit): Promise<findWithInitialDataResponse> => {

  return customFetchProtected<findWithInitialDataResponse>(getFindWithInitialDataUrl(),
  {
    ...options,
    method: 'GET'


  }
);}


export type createIfNotExistsResponse200 = {
  data: void
  status: 200
}

export type createIfNotExistsResponseSuccess = (createIfNotExistsResponse200) & {
  headers: Headers;
};
;

export type createIfNotExistsResponse = (createIfNotExistsResponseSuccess)

export const getCreateIfNotExistsUrl = () => {




  return `/api/v1/accounts`
}

export const createIfNotExists = async ( options?: RequestInit): Promise<createIfNotExistsResponse> => {

  return customFetchProtected<createIfNotExistsResponse>(getCreateIfNotExistsUrl(),
  {
    ...options,
    method: 'POST'


  }
);}


export type existsByIdentifierResponse200 = {
  data: boolean
  status: 200
}

export type existsByIdentifierResponseSuccess = (existsByIdentifierResponse200) & {
  headers: Headers;
};
;

export type existsByIdentifierResponse = (existsByIdentifierResponseSuccess)

export const getExistsByIdentifierUrl = () => {




  return `/api/v1/accounts/exists`
}

export const existsByIdentifier = async ( options?: RequestInit): Promise<existsByIdentifierResponse> => {

  return customFetchProtected<existsByIdentifierResponse>(getExistsByIdentifierUrl(),
  {
    ...options,
    method: 'GET'


  }
);}


